import Vue from 'vue'
import Router from 'vue-router'
import LoginView from '@/components/views/Login'
import HomeView from '@/components/views/Home'
import DashboardView from '@/components/views/Dashboard'
import FAQView from '@/components/views/Faq'
import MaterialsView from '@/components/views/Materials'
import ListNews from '@/components/views/ListNews'
import NewLabelsView from '@/components/views/NewLabels'
import ProductStatsView from '@/components/views/Statistics/ProductStatistics'
import TopSellerView from '@/components/views/Statistics/TopSeller'
import StoreWindowView from '@/components/views/Statistics/StoreWindow'
import UsersView from '@/components/views/Accounting/Users'
import CompanyView from '@/components/views/Accounting/Company'
import SPAuthView from '@/components/views/Accounting/SPAuthView'
import StoresView from '@/components/views/Accounting/Stores'
import StoresStatusView from '@/components/views/Accounting/StoreStatus'
import SingleStoreView from '@/components/views/Accounting/SingleStore'
import BillsView from '@/components/views/Downloads/Bills'
import SapBillsView from '@/components/views/Downloads/SapBills'
import SapServiceBillsView from '@/components/views/Downloads/SapServiceBills'
import CCDownloadView from '@/components/views/Downloads/ClickAndCollect'
import ShipcloudView from '@/components/views/Downloads/ShipcloudLabels'
import TrackingCodesView from '@/components/views/Downloads/TrackingCodesView'
import OrderListView from '@/components/views/Downloads/OrderList'
import FilesView from '@/components/views/Downloads/Files'
import ReportsView from '@/components/views/Downloads/Reports'
import OrdersOverview from '@/components/views/OrdersOverview'
import Points from '@/components/views/Downloads/Points'
import SingleOrderView from '@/components/views/SingleOrder'
import SingleProductView from '@/components/views/SingleProduct'
import OrderWithTokenView from '@/components/views/SingleOrderWithToken'
import PicklistView from '@/components/views/PicklistView'
import ConfirmAccountView from '@/components/views/ConfirmAccount'
import UvpView from '@/components/views/Settings/Uvp'
import Optimizer from '@/components/views/Settings/Optimizer'
import TamarisOptimizer from '@/components/views/Settings/TamarisOptimizer'
import ClickCollectView from '@/components/views/ClickCollectOverview'
import SingleClickCollectView from '@/components/views/SingleClickCollect'
import Overview from '@/components/views/Overview'
import LabelErrors from '@/components/views/Observation/Labels'
import GaxsysView from '@/components/views/Directsale/GaxsysView'
import AmazonView from '@/components/views/Directsale/AmazonView'
import OverviewUnknown from '@/components/views/OverviewUnknown'
import AmazonConfiguration from '@/components/views/AmazonConfiguration';
import AvenduView from "@/components/views/Directsale/AvenduView";
import GeneralSettingsView from "@/components/views/Directsale/GeneralSettingsView.vue";

Vue.use(Router)

export default new Router({
  linkActiveClass: 'active',
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'LoginView',
      component: LoginView
    },
    {
      path: '/confirm',
      name: 'ConfirmAccountView',
      component: ConfirmAccountView
    },
    {
      path: '/password-reset',
      name: 'password_reset',
      component: ConfirmAccountView
    },
    {
      path: '/order-detail',
      component: OrderWithTokenView
    },
    {
      path: '/picklist',
      component: PicklistView,
      name: 'picklist'
    },
    {
      path: '/home',
      component: HomeView,
      children: [
        {
          path: '',
          component: DashboardView,
          name: 'dashboard',
          meta: {
            auth: true
          },
          description: 'dashboard'
        },
        {
          path: '/orders',
          component: OrdersOverview,
          name: 'orders',
          meta: {
            auth: true
          },
          description: 'Orders Table'
        },
        {
          path: '/orders/:id',
          component: SingleOrderView,
          name: 'single_order',
          meta: {
            auth: true
          },
          description: 'Single Order'
        },
        {
          path: '/click-and-collect',
          component: ClickCollectView,
          name: 'click-and-collect',
          meta: {
            auth: true
          }
        },
        {
          path: '/click-and-collect/:id',
          component: SingleClickCollectView,
          name: 'reservations_single',
          meta: {
            auth: true
          }
        },
        {
          path: '/productmanagement/products',
          component: ProductStatsView,
          name: 'products',
          meta: {
            auth: true
          },
          description: 'Statistics viewer'
        },
        {
          path: '/productmanagement/products/:id',
          component: SingleProductView,
          name: 'single_product',
          meta: {
            auth: true
          },
          description: 'Single Product'
        },
        {
          path: '/productmanagement/top-seller',
          component: TopSellerView,
          name: 'top-seller',
          meta: {
            auth: true
          },
          description: 'Top Selling Products'
        },
        {
          path: '/productmanagement/storewindow',
          component: StoreWindowView,
          name: 'storewindow',
          meta: {
            auth: true
          },
          description: 'Store window actions'
        },
        {
          path: '/directsale/general-settings',
          component: GeneralSettingsView,
          name: 'general-settings',
          meta: {
            auth: true
          },
          description: 'General settings'
        },
        {
          path: '/directsale/gaxsys',
          component: GaxsysView,
          name: 'gaxsys',
          meta: {
            auth: true
          },
          description: 'Gaxsys configuration'
        },
        {
          path: '/directsale/amazon',
          component: AmazonView,
          name: 'amazon',
          meta: {
            auth: true
          },
          description: 'Amazon configuration'
        },
        {
          path: '/directsale/avendu',
          component: AvenduView,
          name: 'avendu',
          meta: {
            auth: true
          },
          description: 'avendu configuration'
        },
        {
          path: '/management/users',
          component: UsersView,
          name: 'users',
          meta: {
            auth: true
          },
          description: 'User handling'
        },
        {
          path: '/management/stores',
          component: StoresView,
          name: 'stores',
          meta: {
            auth: true
          },
          description: 'Stores handling'
        },
        {
          path: '/management/stores/:id',
          component: SingleStoreView,
          name: 'store',
          meta: {
            auth: true
          },
          description: 'Store handling'
        },
        {
          path: '/management/company',
          component: CompanyView,
          name: 'company',
          meta: {
            auth: true
          },
          description: 'Company handling'
        },
        {
          path: '/management/company/SPAuth',
          component: SPAuthView,
          name: 'sp_auth',
          meta: {
            auth: true
          },
          description: 'Company handling'
        },
        {
          path: '/management/status',
          component: StoresStatusView,
          name: 'stores_status',
          meta: {
            auth: true
          },
          description: 'Stores status handling'
        },
        {
          path: '/downloads/orders',
          parent: 'accounting',
          component: OrderListView,
          name: 'orders',
          meta: {
            auth: true
          },
          description: 'Orders management'
        },
        {
          path: '/downloads/files',
          parent: 'accounting',
          component: FilesView,
          meta: {
            auth: true
          },
          name: 'files',
          description: 'Files management'
        },
        {
          path: '/downloads/click-and-collect',
          parent: 'accounting',
          component: CCDownloadView,
          meta: {
            auth: true
          },
          name: 'click-and-collect'
        },
        {
          path: '/downloads/shipcloud-receipts',
          parent: 'accounting',
          component: ShipcloudView,
          meta: {
            auth: true
          },
          name: 'shipcloud-receipts'
        },
        {
          path: '/downloads/monthly-reports',
          parent: 'accounting',
          component: ReportsView,
          meta: {
            auth: true
          },
          name: 'monthly-reports',
          description: 'Monthly reports management'
        },
        {
          path: '/downloads/tracking-codes',
          parent: 'accounting',
          component: TrackingCodesView,
          meta: {
            auth: true
          },
          name: 'tracking-codes',
          description: 'Download Tracking codes for specified date'
        },
        {
          path: '/bills/bills',
          parent: 'accounting',
          component: SapBillsView,
          meta: {
            auth: true
          },
          name: 'bills',
          description: 'Invoice management'
        },
        {
          path: '/bills/service-bills',
          parent: 'accounting',
          component: SapServiceBillsView,
          meta: {
            auth: true
          },
          name: 'service-bills',
          description: 'Service Invoice management'
        },
        {
          path: '/bills/archived-bills',
          parent: 'accounting',
          component: BillsView,
          meta: {
            auth: true
          },
          name: 'archived-bills',
          description: 'Invoice management'
        },
        {
          path: '/settings/pricing-rules',
          component: Optimizer,
          name: 'pricing-rules',
          meta: {
            auth: true
          },
          description: 'UVP Config'
        },
        {
          path: '/settings/tamaris-pricing-rules',
          component: TamarisOptimizer,
          name: 'tamaris-pricing-rules',
          meta: {
            auth: true
          },
          description: 'Tamaris UVP Config'
        },
        {
          path: '/overview/unknown-status',
          component: OverviewUnknown,
          name: 'unknown-status',
          meta: {
            auth: true
          }
        },
        {
          path: '/overview/labels',
          component: LabelErrors,
          meta: {
            auth: true
          },
          name: 'label_errors',
          description: 'Label Errors'
        },
        {
          path: '/overview/:type',
          component: Overview,
          name: 'overview',
          meta: {
            auth: true
          }
        },
        {
          path: '/create-label',
          component: NewLabelsView,
          name: 'create-label',
          meta: {
            auth: true
          },
          description: 'New Labels'
        },
        {
          path: '/faq',
          component: FAQView,
          name: 'FAQ',
          meta: {
            auth: true
          },
          description: 'Frequently asked questions'
        },
        {
          path: '/materials-order',
          component: MaterialsView,
          name: 'materials-order',
          meta: {
            auth: true
          },
          description: 'Material Bestellung'
        },
        {
          path: '/notifications',
          component: ListNews,
          name: 'notifications',
          meta: {
            auth: true
          },
          description: 'News'
        },
        {
          path: '/settings/uvp',
          component: UvpView,
          name: 'UVP',
          meta: {
            auth: true
          },
          description: 'UVP Config'
        },
        {
          path: '/downloads/points',
          parent: 'accounting',
          component: Points,
          meta: {
            auth: true
          },
          name: 'merchant_points'
        },
        {
          path: '/directlisting/amazon',
          component: AmazonConfiguration,
          meta: {
            auth: true
          },
          name: 'AmazonConfiguration'
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js